module.exports = __webpack_public_path__ + "assets/img/applet.4bab2f6b.jpg";